import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { ApiStatusResponse } from '@ps/utils';

@Injectable({ providedIn: 'root' })
export class SurveyProcessingApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;

  public updateManualProcessing(
    buyerConfigSettingsId: string,
    companyId: number,
    enable: boolean,
  ): Observable<void> {
    return this._http
      .put<ApiStatusResponse>(
        `${this._baseUrl}/buyerConfigSettings/${buyerConfigSettingsId}`,
        { id: companyId, config: 'enableManualProcessing', enable },
      )
      .pipe(map(() => undefined));
  }
}
